import { FileSpreadsheet, Loader2, Printer } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { useDownloadTimesheet } from "../../hooks/use-download-timesheet";
import type { TimesheetFormat } from "../../types";

const FAILURE_MESSAGES: Record<TimesheetFormat, string> = {
	pdf: "Não foi possível gerar o PDF.",
	csv: "Não foi possível gerar o CSV.",
};

export function ExportButtons({
	month,
	disabled,
}: {
	month: string;
	disabled: boolean;
}) {
	const download = useDownloadTimesheet(month);
	const pendingFormat = download.isPending ? download.variables : undefined;

	async function onDownload(format: TimesheetFormat) {
		try {
			await download.mutateAsync(format);
		} catch {
			toast.error(FAILURE_MESSAGES[format]);
		}
	}

	return (
		<div className="export-buttons">
			<Button
				type="button"
				variant="outline"
				disabled={disabled || download.isPending}
				aria-busy={pendingFormat === "pdf"}
				onClick={() => onDownload("pdf")}
			>
				{pendingFormat === "pdf" ? (
					<Loader2 className="export-buttons__spinner" />
				) : (
					<Printer />
				)}
				Imprimir PDF
			</Button>
			<Button
				type="button"
				variant="outline"
				disabled={disabled || download.isPending}
				aria-busy={pendingFormat === "csv"}
				onClick={() => onDownload("csv")}
			>
				{pendingFormat === "csv" ? (
					<Loader2 className="export-buttons__spinner" />
				) : (
					<FileSpreadsheet />
				)}
				Baixar CSV
			</Button>
		</div>
	);
}
